module.exports = __webpack_public_path__ + "static/img/rectangularValve.57791c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rectangularValve.png
// module id = tO1c
// module chunks = 1